import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import FilterWrap from 'components/atoms/FilterWrap';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';
import TopMediaStatisticsGraph from './TopMediaStatisticsGraph';
import queryString from 'query-string';
import MbSelectbox from 'components/molecules/MbSelectbox';
import i18next from 'i18next';

const useStyles = makeStyles((theme) => ({
  marginRight: {
    display: 'inline-flex',
    marginRight: 5,
  },
}));

let initialization = false;

const filterList = [
  {
    CODE_ID: 5,
    CODE_DESC: '5' + i18next.t('개'),
  },
  {
    CODE_ID: 10,
    CODE_DESC: '10' + i18next.t('개'),
  },
  {
    CODE_ID: 15,
    CODE_DESC: '15' + i18next.t('개'),
  },
  {
    CODE_ID: 20,
    CODE_DESC: '20' + i18next.t('개'),
  },
  {
    CODE_ID: 30,
    CODE_DESC: '30' + i18next.t('개'),
  },
];
let initParam = {
  limit: 5,
};
const Statistics = ({ location }) => {
  const { adverId, mediaScriptNo, advrtsTpCode } = queryString.parse(
    location.search
  );

  if (typeof adverId !== 'undefined') initParam.adverId = adverId;

  if (typeof mediaScriptNo !== 'undefined')
    initParam.mediaScriptNo = mediaScriptNo;

  if (typeof advrtsTpCode !== 'undefined')
    initParam.advrtsTpCode = advrtsTpCode;

  const classes = useStyles();

  // 공통 필터에서 초기값 받아왔는지 확인
  const [getInitParam, setGetInitParam] = useState(false);
  const [params, setParams] = useState(initParam);
  const [codeId, setCodeId] = useState(0);

  useEffect(() => {
    // 렌더링 후에 실행됨
    // params setting(필터링 혹은 초기 param setting) > 렌더링 > 초기화 값 초기화
    initialization = false;
  }, [params]);

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    initialization = true;
    setParams(initParam);
  };

  const getParam = (newParams) => {
    if (getInitParam === false) {
      initParam = {
        ...initParam,
        ...newParams,
      };
    }
    setGetInitParam(true);

    setParams({
      ...params,
      ...newParams,
    });
  };

  /**
   * option 리스트 만들어주는 함수
   * @param {Array} data option list 만들 array
   * @param {string} optionLabelKey option에 나올 label key 값
   * @param {string} optionValueKey option value key 값
   */
  const makeOptionList = (data, optionLabelKey, optionValueKey) => {
    if (typeof data === 'undefined') {
      return [];
    }
    const result = [...data];
    const defaultOption = {
      [optionLabelKey]: '알수없음',
      [optionValueKey]: null,
    };
    if (data.length === 0) {
      result.push(defaultOption);
    }

    return result;
  };
  /**
   * selectbox 필터 선택
   * @param {string} name
   * @param {*} value
   */
  const handleFilterChange = (name, index) => {
    let newParams = {
      ...params,
      [name]: filterList[index].CODE_ID,
    };

    getParam(newParams);
    setCodeId(index);
  };

  return (
    <>
      <FilterWrap handleOnReset={handleOnReset}>
        <StatisticsCommonFilter
          initialization={initialization}
          getParam={getParam}
          nonePltfomTpCodeFilter={true}
          noneDisplayFilter={true}
          noneExternalFilter={true}
        />
        <div className={classes.marginRight}>
          <MbSelectbox
            label={i18next.t('상위매체갯수')}
            value={codeId}
            itemindex={codeId}
            name="limit"
            className={classes.marginRight}
            optionData={makeOptionList(filterList, 'CODE_DESC', 'CODE_ID')}
            optionLabelKey="CODE_DESC"
            optionValueKey="CODE_ID"
            handleOnchange={handleFilterChange}
            icon={false}
          />
        </div>
      </FilterWrap>
      {getInitParam && (
        <>
          <TopMediaStatisticsGraph params={{ ...params }} />
        </>
      )}
    </>
  );
};

export default withRouter(Statistics);
